import { useCallback } from 'react';

import { useEbookSubmissionLazyQuery } from '../core/graphql/operation-hooks';

const useQueryEbookSubmission = () => {
  const [queryEbookSubmission, { data, loading }] = useEbookSubmissionLazyQuery({ fetchPolicy: 'network-only' });

  const fetchEbookSubmission = useCallback(
    (ebookSubmissionId: string) => {
      queryEbookSubmission({ variables: { ebookSubmissionId } });
    },
    [queryEbookSubmission],
  );

  return {
    fetchEbookSubmission,
    ebookSubmission: data?.ebookSubmission,
    isLoadingEbookSubmission: loading,
  };
};

export default useQueryEbookSubmission;
